import React, { useState , useEffect, useRef } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faCheckCircle } from '@fortawesome/free-solid-svg-icons';

import { useOutsideClick } from '../js/Helpers';

export default function Dropdown({ data, currentValue, displayDefault = null, backgroundClass=null, colorClass=null, handleChange = ()=>{}, disabled=false, className='' }) {
	const ref = useRef();
	const formatDisplayText = (value) => {
		if(value === null || value === undefined) return '';
		return (typeof value === 'string' || typeof value === 'number') ? `${value}` : '';
	};
	
	const [visible, setVisible] = useState(false);
	
	const toggleVisible = (e) => {
		setVisible(!visible);
	}
	
	useOutsideClick(ref, () => {
		setVisible(false);
	});

	useEffect(() => {
		if(!visible) return;

		const handlePointerDownOutside = (e) => {
			if(ref.current && !ref.current.contains(e.target))
			{
				setVisible(false);
			}
		};

		document.addEventListener('mousedown', handlePointerDownOutside);
		document.addEventListener('touchstart', handlePointerDownOutside);

		return () => {
			document.removeEventListener('mousedown', handlePointerDownOutside);
			document.removeEventListener('touchstart', handlePointerDownOutside);
		};
	}, [visible]);
	
	const selectOption = (e) => {
		const optionRow = e.currentTarget;
		const new_value = optionRow.getAttribute('data-value');
		const selected_option = (data) ? data.find(option => `${option.value}` === `${new_value}`) : null;
		if(selected_option && selected_option.option_is_group_label) return;

		const display = formatDisplayText(selected_option ? selected_option.display : null);
		const parentDiv = optionRow.closest('.dropdown-container');
		const dropdownDisplay = parentDiv ? parentDiv.querySelector('.dropdown-display') : null;
		
		if(dropdownDisplay)
		{
			dropdownDisplay.innerHTML = display;
			dropdownDisplay.setAttribute('data-value', new_value);
			dropdownDisplay.setAttribute('title', display);
		}
		
		if(handleChange) handleChange(new_value);
	}
	
	useEffect(() => {
		if(visible)
		{
			const selected_option = document.getElementsByClassName('dropdown-option-selected')[0];
			
			if(selected_option) selected_option.parentNode.scrollTop = selected_option.offsetTop;
		}
	}, [visible]);
	
	const display_value_from_data = (data) ? data.find(option => option.value === currentValue) : null;
	const display = (display_value_from_data !== undefined) ? display_value_from_data.display : (disabled ? 'N/A' : displayDefault);
	const display_title = formatDisplayText(display);
	
	return (
		<div className={`dropdown-container ${className} ${backgroundClass} ${(backgroundClass && backgroundClass !== 'white') && 'no-border'} ${disabled ? 'dropdown-disabled' : ''}`} onClick={!disabled ? toggleVisible : null} ref={ref}>
			<div className={`dropdown-display dropdown-display-default ${colorClass ? colorClass + '-text' : null}`} data-value={currentValue} title={display_title || undefined}>{display}</div>
			{!disabled &&
				<FontAwesomeIcon className={`dropdown-arrow ${colorClass ? colorClass + '-text' : null}`} icon={faAngleDown}/>
			}
			{visible &&
				<div className='dropdown-options-container'>
					{data.map((row, i) => {
						const has_status = (typeof row.option_status_selected === 'boolean');
						const is_group_label = !!row.option_is_group_label;
						return (
							<div className={`dropdown-option ${row.value === currentValue ? 'dropdown-option-selected' : ''} ${has_status ? 'dropdown-option-with-status' : ''} ${is_group_label ? 'dropdown-option-group-label' : ''}`} onClick={!is_group_label ? selectOption : undefined} data-value={row.value} key={i} title={formatDisplayText(row.display) || undefined}>
								{has_status ? (
									<>
										<div className='dropdown-option-label'>{row.display}</div>
										<FontAwesomeIcon className={`dropdown-option-status-icon ${row.option_status_selected ? 'green-text' : 'light-gray-text'}`} icon={faCheckCircle}/>
									</>
								): (
									row.display
								)}
							</div>
						)
					})}
				</div>
			}
		</div>
	);
}
